import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { signer,transfer,balanceOf } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getIdoInfo, addIdoBnb,getIdoPend,addSwap} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Swap = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [coin,setCoin] = useState("usdt")
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
   const [meba,setMeba] = useState("")
   
    const [receive,setReceiveAddress] = useState("")
   
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(0)
const [vrp,setVrp]=useState(0)
const [price,setPrice]=useState(0)
const [price1,setPrice1]=useState(0)
const [hua,setHua]=useState(0)
const [fee,setFee]=useState(0)
 
 const [valueDep,setValueDep] = useState("")
 const [valueOut,setValueOut] = useState("")

 const [edu,setEdu] = useState(0)
   

    
    
    const ref = useRef()

    


 

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getIdoInfo().then(res=>{
                if(res.code == 0){
                    setPrice(res.data.price)
                let _price = 0
                _price = 1 / res.data.price
                setPrice1(_price)
                
                setMeba(res.data.meba)

                setVrp(res.data.vrp)
                setReceiveAddress(res.data.receive)
                
                setHua(res.data.hua)
                setFee(res.data.swapFee)
                  setList(res.data.list || [])
                    
                   
                   
                   
                   
                   
                  
                 
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    

  

  

   

 

 
     const _rand=  () =>{
        // message.error(t('g.暂未开放'))
        //        return
                if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先绑定地址'))
                return false
            }
           
            // if(props.address.length<=0) return false
        
    
            // if(receive.length === 0){
            //     message.error(t('asset.区块合约错误'))
            //     return false
            // }
    
            
            
            if(!valueDep){
                message.error(t('swap.请输入数量'))
                return false
            }
            if(valueDep.length<=0){
                message.error(t('asset.请输入数量'))
                return false
            }

            // if(valueDep<=0.001){
            //         message.error(t('asset.最低')+":0.001")
            //         return false
            //     }

           if(valueDep<1){
                    message.error(t('asset.最低')+":1")
                    return false
                }
                if(parseFloat(valueDep)>parseFloat(meba)){
          
                    message.error(t('swap.您的剩余额度不足'))
                    return false
                }
    
            if(isLock){
                return false
            }
            setIsLock(true)

               signer(props.address).then(res1=>{
                                    addSwap({
                                        address:props.address,
                                        value:valueDep.toString()
                                    }).then(
                                        res=>{
                                            message.success(res.msg)
                                            
                                            setNum(num+1);
                                            setIsLock(false)
                                        },error=>{
                                            setIsLock(false)
                                            message.error(error)
                                        })
                                },error=>{
                                    setIsLock(false)
                                     message.error(error)
                                })
    
            
    
    
        }
    

   const _max = () =>{
     getBcb(balanceUsdt)
   }

   const getBcb = (e)=>{
    console.log(e)
    if(e<0){
        return
    }
    if(price==0){
        return
    }
    setValueDep(e)
    let out = parseInt(e  / price  *10000) /10000
    setValueOut(out)
   }

  


   

 

   

 
  





    useEffect(() => {
        console.log(nowTime)
        props.setIsTiao(true)
        window.scrollTo(0, 0)
            

          
             _getTuanInfo()
           
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div  className=' indexBg33 w-full lg:w-1/3   pt-16 text-white flex flex-col z-10'>
                <div className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                    <div  className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img onClick={()=>window.history.back()} alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-lg oblod text-gray-100'>{t('swap.兑换')}VRP </span>
                    </div>
                    {/* <div className='w-2/3 flex flex-row justify-end px-0 '>
                    {
                        tab==0?(
                            <>
                            <span className='px-2 pb-2 block border-b border-[#1D46AF] text-[#1D46AF]'>{t('mint.铸造模式')}</span>
                            <span onClick={()=>setTab(1)} className='ml-4 px-2 pb-2 block text-gray-500'>{t('mint.节点模式')}</span>
                            </>
                        ):(
                            <>
                            <span onClick={()=>setTab(0)} className='px-2 pb-2 block  text-gray-500'>{t('mint.铸造模式')}</span>
                            <span className='ml-4 px-2 pb-2 block border-b border-[#1D46AF] text-[#1D46AF]'>{t('mint.节点模式')}</span>
                            </>
                        )
                    }
                    
                    
                    </div> */}
                </div>
                {/*  */}
              

        

                {/* <div className=' w-full px-4'>
                        <div onClick={_rand} class=" mb-2 px-6 py-5 rounded-lg bg-gradient-to-b from-[#0161F6] to-[#030D54] border border-[#01409f] flex flex-row justify-center items-center ">
                            <span class="mr-2">{t('swap.查看BCBSE行情走势')}</span>
                            <svg t="1769328644488" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21427" width="15" height="15"><path d="M892 928.1H134c-19.9 0-36-16.1-36-36v-758c0-19.9 16.1-36 36-36h314.1c19.9 0 36 16.1 36 36s-16.1 36-36 36H170v686h686V579.6c0-19.9 16.1-36 36-36s36 16.1 36 36v312.5c0 19.9-16.1 36-36 36z" fill="#1B43FD" p-id="21428"></path><path d="M927.9 131.6v-0.5c-0.1-1.7-0.4-3.3-0.7-4.9 0-0.1 0-0.2-0.1-0.3-0.4-1.7-0.9-3.3-1.5-4.9v-0.1c-0.6-1.6-1.4-3.1-2.2-4.6 0-0.1-0.1-0.1-0.1-0.2-0.8-1.4-1.7-2.8-2.7-4.1-0.1-0.1-0.2-0.3-0.3-0.4-0.5-0.6-0.9-1.1-1.4-1.7 0-0.1-0.1-0.1-0.1-0.2-0.5-0.6-1-1.1-1.6-1.6l-0.4-0.4c-0.5-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.6-0.5-1.2-1-1.9-1.4-0.1-0.1-0.3-0.2-0.4-0.3-1.4-1-2.8-1.8-4.3-2.6l-0.1-0.1c-1.6-0.8-3.2-1.5-4.9-2-1.6-0.5-3.3-1-5-1.2-0.1 0-0.2 0-0.3-0.1l-2.4-0.3h-0.3c-0.7-0.1-1.3-0.1-2-0.1H640.1c-19.9 0-36 16.1-36 36s16.1 36 36 36h165L487.6 487.6c-14.1 14.1-14.1 36.9 0 50.9 7 7 16.2 10.5 25.5 10.5 9.2 0 18.4-3.5 25.5-10.5L856 221v162.8c0 19.9 16.1 36 36 36s36-16.1 36-36V134.1c0-0.8 0-1.7-0.1-2.5z" fill="#1B43FD" p-id="21429"></path></svg>
                        </div>
                </div> */}
                        

                {/*  */}
                
                
                 <div className="w-full mt-5 py-15  px-4 ">
                            <div className="container">
                            
                                <div className="   mt-0 flex flex-col gap-6 bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]   p-4 pb-2">
                                <div className="flex basis-full flex-col mb-2 ">
                                    <div className="flex flex-row justify-start items-center">
                                    
                                       
                                        <div className="w-1/3 flex flex-row justify-start items-center text-sm font-semibold text-gray-100 ">
                                            {t('swap.消耗')}
                                        </div>
                                        <div className="w-2/3 h-10 flex flex-row justify-end items-center text-base font-semibold text-gray-100 ">    
                                            <span>{t('swap.额度')}</span>
                                            <div className="mx-2 w-[50px]   rounded-md flex flex-row items-center px-4 text-[#FC5F7B] border border-pink-500/20 bg-pink-400/20"  >
                                                {meba}
                                                
                                            </div>
                                            {/* <span className=' text-yellow-600'>USDT</span> */}
                                        </div>
                                    </div>
                                    <div className='w-full mt-2 py-2 px-4 h-16 bg-[#342F53] rounded-xl flex flex-row items-center justify-between'>
                                        <div className='w-[140px] h-10 pl-2 bg-[#282440] rounded-3xl flex flex-row items-center justify-start'>
                                            <img alt='rr' className=' mr-2' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img>
                                            <span className=' text-base oblack text-gray-100'>{t('swap.额度')}</span>
                                        </div>
                                        <div className="w-[200px] h-10  rounded-md flex flex-row items-center justify-end pl-4" >
                                            <input onInput={(e)=>getBcb(e.target.value)} value={valueDep}  type="number"   className=' w-full h-10 text-lg text-gray-100 input1  text-right' placeholder={t('swap.输入数量')}></input>
                                            
                                        </div>
                                    </div>
                                    <div className="flex flex-row mt-2 justify-end items-center ">
                                    
                                        {/* <div className="w-2/3  flex flex-row justify-end items-center text-xs  text-gray-100 ">
                                            <span>{t('swap.余额')}</span>
                                            <span className='mx-2'>
                                                <CountUp start={0} end={balanceUsdt} duration="1" decimals={4} />
                                                </span>
                                           
                                            <span onClick={_max} className=' text-yellow-600'>{t('swap.最大')}</span>
                                        </div> */}
                                    </div>

                                    <div className="mt-5 flex flex-row justify-center items-center relative">
                                    
                                       
                                        <div className="w-1/3 flex flex-row justify-start items-center text-sm font-semibold text-gray-100 ">
                                            {t('swap.接收')}
                                        </div>
                                        <button class="bg-[#282440]  rounded-full p-2 absolute"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-horizontal w-6 h-6 text-white/50 rotate-90" aria-hidden="true"><path d="m18 8 4 4-4 4"></path><path d="M2 12h20"></path><path d="m6 8-4 4 4 4"></path></svg></button>
                                        <div className="w-2/3 h-10 flex flex-row justify-end items-center text-sm  text-gray-500 ">
                                            <span>{t('swap.交易手续费')}</span>
                                           
                                            <span >{0}%</span>
                                        </div>
                                    </div>
                                    {/* bg-[#10276a] */}
                                    <div className='w-full mt-4 py-2 px-4 h-16 bg-[#342F53] rounded-xl flex flex-row items-center justify-between'>
                                        <div className='w-[140px] h-10 pl-2 bg-[#282440] rounded-3xl flex flex-row items-center justify-start'>
                                            <img alt='rr' className=' mr-2' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img>
                                            <span className=' text-base oblack text-gray-100'>VRP</span>
                                        </div>
                                        <div className="w-[200px] h-10  rounded-md flex flex-row items-center justify-end pl-4" >
                                            <input disabled  value={valueOut}  type="number"   className=' w-full h-10 text-lg text-gray-100 input1  text-right' placeholder=''></input>
                                            
                                        </div>
                                    </div>
                                    <div className="flex flex-row mt-2 justify-end items-center ">
                                    
                                        <div className="w-2/3  flex flex-row justify-end items-center text-xs  text-gray-100 ">
                                            <span>{t('swap.余额')}</span>
                                            <span className='mx-2'>
                                                <CountUp start={0} end={vrp} duration="1" decimals={4} />
                                                </span>
                                           
                                            
                                        </div>
                                    </div>

                                    <div className='w-full mt-4 py-2 px-4 h-14 bg-[#282440] rounded-xl flex flex-row items-center justify-between'>
                                        
                                            
                                            <span className=' text-sm  text-gray-300'>{t('swap.兑换价格')}</span>
                                       
                                       
                                          
                                             <span className=' text-sm  text-gray-300'>1 额度 = <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={price1}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} /> VRP</span>
                                        
                                    </div>




                                   

                                    <div className=' w-full mt-8 mb-4 flex flex-row justify-end items-center'>
                                        <button onClick={_rand}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className='w-full h-12  hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('swap.即将上线')}</span></button>
                                    </div>

                                     <div className=' w-full px-4 mt-5'>
                                        <div class="  px-6 flex flex-row justify-center items-center ">
                                            <span class="mr-2 text-xs  text-gray-500">{t('swap.交易流动性由 VRP DAO 提供')}</span>
                                            <svg t="1769328644488" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21427" width="15" height="15"><path d="M892 928.1H134c-19.9 0-36-16.1-36-36v-758c0-19.9 16.1-36 36-36h314.1c19.9 0 36 16.1 36 36s-16.1 36-36 36H170v686h686V579.6c0-19.9 16.1-36 36-36s36 16.1 36 36v312.5c0 19.9-16.1 36-36 36z" fill="#1B43FD" p-id="21428"></path><path d="M927.9 131.6v-0.5c-0.1-1.7-0.4-3.3-0.7-4.9 0-0.1 0-0.2-0.1-0.3-0.4-1.7-0.9-3.3-1.5-4.9v-0.1c-0.6-1.6-1.4-3.1-2.2-4.6 0-0.1-0.1-0.1-0.1-0.2-0.8-1.4-1.7-2.8-2.7-4.1-0.1-0.1-0.2-0.3-0.3-0.4-0.5-0.6-0.9-1.1-1.4-1.7 0-0.1-0.1-0.1-0.1-0.2-0.5-0.6-1-1.1-1.6-1.6l-0.4-0.4c-0.5-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.6-0.5-1.2-1-1.9-1.4-0.1-0.1-0.3-0.2-0.4-0.3-1.4-1-2.8-1.8-4.3-2.6l-0.1-0.1c-1.6-0.8-3.2-1.5-4.9-2-1.6-0.5-3.3-1-5-1.2-0.1 0-0.2 0-0.3-0.1l-2.4-0.3h-0.3c-0.7-0.1-1.3-0.1-2-0.1H640.1c-19.9 0-36 16.1-36 36s16.1 36 36 36h165L487.6 487.6c-14.1 14.1-14.1 36.9 0 50.9 7 7 16.2 10.5 25.5 10.5 9.2 0 18.4-3.5 25.5-10.5L856 221v162.8c0 19.9 16.1 36 36 36s36-16.1 36-36V134.1c0-0.8 0-1.7-0.1-2.5z" fill="#1B43FD" p-id="21429"></path></svg>
                                        </div>
                                </div>
                                                    
                                </div>
                                
                                </div>
                            </div>
                        </div>
                
                {/*  */}
               <>
                        <div className='mt-8 w-full flex flex-row px-4 justify-center'>
                            <span className='px-2 pb-2  text-gray-100 text-base'>{t('swap.交易记录')}</span>
                        </div>
                        <div className='  mt-5 mx-4  pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                        {
                            list.length>0?
                            list.map((item,index)=>{
                                return(
                                    <>
                                    <div className='px-4 mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                        <div className=' w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-xs flex flex-col'>
                                                <span className=' text-sm'>{t('mint.记录时间')}</span>
                                                <span className='text-xs mt-1 text-gray-100'>{item.add_time}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.状态')}</span>
                                                {
                                                    item.state==0?(
                                                        <span className='text-sm text-green-500 block '>{t('mint.已确认')}</span>
                                                    ):(
                                                        <span className='text-sm text-red-600 block '>{t('mint.确认中')}</span>
                                                    )
                                                }
                                                
                                            </div>
                                        </div>
                                        <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-sm flex flex-col '>
                                                <span>{t('swap.消耗额度')} </span>
                                                <span className='text-xs mt-1 text-pink-500'>
                                                   <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.meba}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /></span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('swap.接收')} VRP</span>
                                                <span className='text-xs mt-1 text-pink-500'>
                                                   <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.token}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /></span>
                                                    
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <div className=' w-full my-4 h-[1px] bg-stone-400/10'></div>
                                    </>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-16 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-lg'>
                                        No data
                                </div>
                            )
                            }
                        
                        
                    </div>
                        
                        </>
                
                
                {/*  */}

               

               

                

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Swap);
